/* Home v2: the original short product sequence uses one video element and timed copy chapters.
   Pause off-screen/in background tabs; reduced motion uses stills until explicit playback.
   The catalogue-backed chooser, shopping rails and GSAP motion are isolated to this page. */
(function () {
  "use strict";
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var phone = matchMedia("(max-width: 700px)");

  function hero(root) {
    var slides = [].slice.call(root.querySelectorAll(".v2-slide"));
    if (!slides.length) return;
    var pauseBtn = root.querySelector("[data-v2-pause]");
    var at = 0, paused = reduce, seen = true, pendingSeek = 0, allowFilm = !reduce;
    var v = root.querySelector("video"), copyTween;
    // One decoder plays the original homepage's seven short product clips.
    function poster() { v.poster = phone.matches ? slides[at].dataset.posterPhone : slides[at].dataset.poster; }
    function load() {
      poster();
      if (!allowFilm) return;
      var src = phone.matches ? v.dataset.srcPhone : v.dataset.src;
      if (v.dataset.loaded !== src) {
        pendingSeek = +slides[at].dataset.start;
        v.src = src; v.dataset.loaded = src; v.load();
      }
    }
    function playing() { return !paused && seen && !document.hidden &&
      (document.documentElement.classList.contains('ld-landed') || document.documentElement.classList.contains('pc-revealing')); }
    function sync() {
      if (playing() && allowFilm) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
      root.classList.toggle("is-paused", paused);
      if (pauseBtn) pauseBtn.setAttribute("aria-label", paused ? "Play the film" : "Pause the film");
    }
    function go(n, continuous) {
      var next = (n + slides.length) % slides.length;
      if (next !== at) {
        slides[at].classList.remove("is-on");
        slides[at].setAttribute("aria-hidden", "true");
        slides[at].inert = true;
        slides[next].classList.add("is-on");
        slides[next].removeAttribute("aria-hidden");
        slides[next].inert = false;
        at = next;
        if (window.gsap && !reduce) {
          if (copyTween) copyTween.kill();
          copyTween = gsap.fromTo(slides[at].querySelectorAll(".v2-hero-copy > *"),
            { y: 24, opacity: 0 }, { y: 0, opacity: 1, duration: .8, stagger: .08, ease: "power3.out", clearProps: "transform,opacity" });
        }
      }
      if (!continuous && allowFilm) {
        pendingSeek = +slides[at].dataset.start;
        if (v.readyState > 0) { v.currentTime = pendingSeek; pendingSeek = null; }
      }
      poster();
      var index = root.querySelector("[data-v2-index]");
      if (index) index.textContent = String(at + 1).padStart(2, "0") + " / " + String(slides.length).padStart(2, "0");
      sync();
    }
    v.addEventListener("loadedmetadata", function () {
      if (pendingSeek !== null) { v.currentTime = pendingSeek; pendingSeek = null; }
      sync();
    });
    v.addEventListener("timeupdate", function () {
      if (!v.seeking && pendingSeek === null && playing() && v.currentTime >= +slides[at].dataset.end - .04) go(at + 1, at < slides.length - 1);
    });
    v.addEventListener("ended", function () { if (playing()) go(0); });
    if (pauseBtn) pauseBtn.addEventListener("click", function () {
      // Reduced-motion visitors can explicitly opt into film playback.
      if (!allowFilm && paused) { allowFilm = true; load(); }
      paused = !paused; sync();
    });
    var prev = root.querySelector("[data-v2-prev]"), next = root.querySelector("[data-v2-next]");
    if (prev) prev.addEventListener("click", function () { go(at - 1); });
    if (next) next.addEventListener("click", function () { go(at + 1); });

    // a sideways swipe steps on phones; an upward one stays the page's
    var x0 = null, y0 = 0;
    root.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    root.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.4) go(at + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });

    if ("IntersectionObserver" in window) new IntersectionObserver(function (es) {
      seen = es[0].isIntersecting; sync();
    }, { threshold: 0.15 }).observe(root);
    document.addEventListener("visibilitychange", sync);
    document.addEventListener('alda:intro-reveal', sync);
    document.addEventListener('alda:landed', sync);
    root.addEventListener("focusin", function (e) {
      if (e.target.closest(".v2-hero-copy")) { paused = true; sync(); }
    });
    var swap = function () { load(); sync(); };
    if (phone.addEventListener) phone.addEventListener("change", swap); else if (phone.addListener) phone.addListener(swap);
    if (window.gsap) root.classList.add("has-gsap");
    load(); go(0);
  }

  // the rails: the arrows move a screenful of cards; each goes quiet at its end
  function rail(r) {
    var track = r.querySelector(".v2-track"), back = r.querySelector("[data-v2-back]"), fwd = r.querySelector("[data-v2-fwd]");
    if (!track) return;
    function step(dir) {
      var card = track.firstElementChild;
      var w = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16) : track.clientWidth;
      var n = Math.max(1, Math.floor(track.clientWidth / w));
      track.scrollBy({ left: dir * n * w, behavior: reduce ? "auto" : "smooth" });
    }
    function ends() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (back) back.setAttribute("aria-disabled", track.scrollLeft <= 2 ? "true" : "false");
      if (fwd) fwd.setAttribute("aria-disabled", track.scrollLeft >= max ? "true" : "false");
    }
    if (back) back.addEventListener("click", function () { step(-1); });
    if (fwd) fwd.addEventListener("click", function () { step(1); });
    track.addEventListener("scroll", ends, { passive: true });
    addEventListener("resize", ends);
    ends();
  }

  function comparison(root) {
    var data = JSON.parse(root.querySelector("[data-compare-data]").textContent);
    var grid = root.querySelector(".v2-compare-grid"), budget = root.querySelector("[data-compare-budget]");
    var selected = {}, money = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 });
    var comparisonSizes = { "fry-pan": { value: 20, unit: "cm", label: "20cm" }, "kadai-wok": { value: 22, unit: "cm", label: "22cm" }, pressure: { value: 3, unit: "L", label: "3L" } };
    function chooseSize(card) {
      var slug = card.dataset.compareProduct, product = data.products[slug];
      var index = Number(card.querySelector("select").value), variant = product.variants[index];
      selected[slug] = index;
      card.querySelector("[data-compare-price]").textContent = variant.soon || money.format(variant.price);
      var mrp = card.querySelector("[data-compare-mrp]");
      mrp.hidden = !!variant.soon || variant.price >= variant.mrp;
      mrp.querySelector("span:last-child").textContent = money.format(variant.mrp);
      card.querySelector("[data-compare-size-label]").textContent = variant.label;
      var image = card.querySelector("img");
      image.src = variant.image; image.alt = product.name + " — " + variant.label;
      var link = card.querySelector("[data-compare-link]");
      link.href = "/products/" + slug + "?size=" + encodeURIComponent(variant.label);
      link.setAttribute("aria-label", "Explore " + product.name + " — " + variant.label);
    }
    function render() {
      var key = root.querySelector('[name="compare-type"]:checked').value;
      var group = data.groups[key], cap = Number(budget.value), fragment = document.createDocumentFragment(), count = 0;
      var comparisonSize = comparisonSizes[key];
      group.slugs.forEach(function (slug) {
        var variants = data.products[slug].variants;
        var preferred = variants.findIndex(function (variant) {
          var size = variant.label.match(/^(\d+(?:\.\d+)?)\s*(cm|L)\b/i);
          return comparisonSize && size && Number(size[1]) === comparisonSize.value && size[2].toLowerCase() === comparisonSize.unit.toLowerCase();
        });
        var allowed = variants.map(function (v, i) { return i; }).filter(function (i) { return !cap || (!variants[i].soon && variants[i].price <= cap); });
        if (!allowed.length) return;
        var card = root.querySelector('[data-compare-template="' + slug + '"]').content.firstElementChild.cloneNode(true);
        var select = card.querySelector("select");
        Array.from(select.options).forEach(function (option) { if (!allowed.includes(Number(option.value))) option.remove(); });
        var index = allowed.includes(selected[slug]) ? selected[slug] : allowed.includes(preferred) ? preferred : allowed.reduce(function (a, b) { return variants[a].price <= variants[b].price ? a : b; });
        select.value = String(index);
        card.querySelector(".v2-compare-size").hidden = false;
        chooseSize(card); fragment.appendChild(card); count++;
      });
      grid.replaceChildren(fragment);
      grid.style.setProperty("--compare-count", Math.max(1, count));
      grid.dataset.count = count; grid.hidden = !count; grid.scrollLeft = 0;
      root.querySelector(".v2-compare-empty").hidden = count !== 0;
      root.querySelector(".v2-compare-more").hidden = count === 0;
      root.querySelector("[data-compare-note]").textContent = comparisonSize ? "Choose a size to compare. " + group.note : group.note;
      root.querySelector("[data-compare-status]").textContent = count + (count === 1 ? " option" : " options") +
        (cap ? " within " + money.format(cap) : "") + (count ? " · Gas & induction" : "");
      root.querySelector(".v2-compare-swipe").hidden = count < 2;
      var all = root.querySelector("[data-compare-all]");
      all.href = group.href;
      all.firstChild.textContent = "Explore all " + ({ "fry-pan": "fry pans", tawa: "tawas", "kadai-wok": "kadais & woks", pressure: "pressure cookers" }[key]) + " ";
      if (window.ScrollTrigger) ScrollTrigger.refresh();
    }
    root.addEventListener("change", function (event) {
      var card = event.target.closest("[data-compare-product]");
      if (card) chooseSize(card); else render();
    });
    root.querySelector("[data-compare-reset]").addEventListener("click", function () {
      budget.value = "0"; render(); budget.focus({ preventScroll: true });
    });
    root.querySelector(".v2-compare-controls").hidden = false;
    root.classList.add("is-details-collapsed");
    root.querySelector("[data-compare-details]").addEventListener("click", function () {
      var expanded = this.getAttribute("aria-expanded") !== "true";
      this.setAttribute("aria-expanded", String(expanded));
      this.querySelector("span:first-child").textContent = expanded ? "Hide the details" : "Compare the details";
      this.querySelector(".v2-compare-plus").textContent = expanded ? "−" : "+";
      root.classList.toggle("is-details-collapsed", !expanded);
      if (window.ScrollTrigger) ScrollTrigger.refresh();
    });
    /* Shopify's prices (2026-11-04, the owner: prices always come from Shopify): the figures this page was built with
       give way to the store's once commerce.js has them (window.aldaPrice, alda:prices) - each size's selling price and
       MRP, and a coming-soon size says so with no figure. Until then commerce.css keeps the cards' prices hidden. */
    var drawn = "";
    function live() {
      var P = window.aldaPrice;
      if (!P || !P.liveAt || !P.family) return;
      Object.keys(data.products).forEach(function (slug) {
        var fam = P.family(slug), template = root.querySelector('[data-compare-template="' + slug + '"]');
        if (!fam) return;
        data.products[slug].variants.forEach(function (v, i) {
          var f = fam.variants.filter(function (x) { return x.label === v.label; })[0];
          if (!f) return;
          v.soon = P.soon(f) ? P.soonFor(f) : "";
          v.price = P.price(f); v.mrp = f.mrp;
          var option = template && template.content.querySelector('option[value="' + i + '"]');
          if (option) option.textContent = v.label + " · " + (v.soon || money.format(v.price));
        });
      });
      var sig = JSON.stringify(data.products);
      if (sig !== drawn) { drawn = sig; render(); }
    }
    document.addEventListener("alda:prices", live);
    render();
    live();
    addEventListener("pageshow", render);
  }

  function motion() {
    if (!window.gsap || !window.ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger);
    var mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", function () {
      document.querySelectorAll(".v2-h").forEach(function (el) {
        if (!el.querySelector(".v2-word-clip")) {
          var text = el.textContent;
          el.setAttribute("aria-label", text);
          el.textContent = "";
          text.split(" ").forEach(function (word, index) {
            if (index) el.appendChild(document.createTextNode(" "));
            var clip = document.createElement("span"), inner = document.createElement("span");
            clip.className = "v2-word-clip"; clip.setAttribute("aria-hidden", "true");
            inner.textContent = word; clip.appendChild(inner); el.appendChild(clip);
          });
        }
        gsap.from(el.querySelectorAll(".v2-word-clip > span"), { yPercent: 110, duration: .9, stagger: .055, ease: "power3.out", clearProps: "transform",
          scrollTrigger: { trigger: el, start: "top 94%", once: true } });
      });
      document.querySelectorAll(".v2-chooser-intro, .v2-band-in").forEach(function (el) {
        gsap.from(el, { y: 28, duration: .9, ease: "power3.out", clearProps: "transform",
          scrollTrigger: { trigger: el, start: "top 94%", once: true } });
      });
      document.querySelectorAll(".v2-track, .v2-hls, .v2-menu-grid").forEach(function (row) {
        // Animate only the initially visible cards; sideways scrolling reveals the rest naturally.
        var cards = Array.from(row.children).filter(function (card) { return card.offsetLeft < row.clientWidth; });
        gsap.from(cards, { y: 36, duration: 1, stagger: .09, ease: "power3.out", clearProps: "transform",
          scrollTrigger: { trigger: row, start: "top 92%", once: true } });
      });
    });
    mm.add("(min-width: 701px) and (prefers-reduced-motion: no-preference)", function () {
      var feature = document.querySelector("[data-feature-parallax]");
      if (!feature) return;
      var image = feature.querySelector(".v2-feature-img");
      if (!image) return;
      feature.classList.add("is-parallax-active");
      // The photograph drifts behind the copy; only its transform changes on scroll.
      gsap.fromTo(image, { yPercent: -8 }, { yPercent: 8, ease: "none",
        scrollTrigger: { trigger: feature, start: "top bottom", end: "bottom top", scrub: .65, invalidateOnRefresh: true } });
      return function () { feature.classList.remove("is-parallax-active"); };
    });
    mm.add("(min-width: 1001px) and (prefers-reduced-motion: no-preference)", function () {
      document.querySelectorAll(".v2-menu-art img").forEach(function (image) {
        gsap.fromTo(image, { y: 12 }, { y: -12, ease: "none",
          scrollTrigger: { trigger: image.closest(".v2-menu-card"), start: "top bottom", end: "bottom top", scrub: 1 } });
      });
    });
  }

  function init() {
    [].forEach.call(document.querySelectorAll("[data-v2-hero]"), hero);
    [].forEach.call(document.querySelectorAll("[data-v2-rail]"), rail);
    [].forEach.call(document.querySelectorAll("[data-v2-compare]"), comparison);
    motion();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
